/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto,
  GetApiV1MePlanningParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMePlanning = () => {
const getApiV1MePlanning = (
    params?: GetApiV1MePlanningParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto[]>(
      {url: `/api/v1/me/planning`, method: 'GET',
        params
    },
      options);
    }
  return {getApiV1MePlanning}};
export type GetApiV1MePlanningResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMePlanning>['getApiV1MePlanning']>>>
